"use client";

import { HoverPopover } from "./HoverPopover";

/**
 * A small "i" with a hover tooltip, for explaining a term in place (a column
 * header, a label).
 */
export function InfoBubble({ text }: { text: string }) {
  return (
    <HoverPopover
      label={text}
      align="center"
      triggerClassName="relative inline-flex cursor-help align-middle text-(--fg-subtle) transition-colors hover:text-(--fg-secondary)"
      trigger={
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden={true}
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      }
      className="w-60 min-w-0 rounded-(--radius-field) px-2.5 py-1.5 text-[11px] leading-[1.45] font-normal text-(--fg-secondary) shadow-xl"
    >
      {text}
    </HoverPopover>
  );
}
